import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { profileDetails } from "../../../services/ProfileService";
import { useSelector } from "react-redux";

const OrganizationCard = () => {
  const { data: user, loading: isLoading } = useSelector(
    (state) => state.profileDetails,
  );
  const organization = user?.organization;

  if (isLoading) {
    return (
      <div className="bg-white p-4 rounded-lg shadow-md animate-pulse">
        <div className="h-16 bg-gray-200 rounded mb-3" />
        <div className="h-4 w-32 bg-gray-200 rounded mb-2" />
        <div className="h-3 w-48 bg-gray-200 rounded mb-2" />
        <div className="h-3 w-24 bg-gray-200 rounded" />
      </div>
    );
  }
  // If no organization → show Create Company
  if (!organization) {
    return (
      <div className="bg-white p-4 rounded-lg shadow-md">
        <div className="text-sm text-gray-600 mb-3">
          You haven't created a company yet.
        </div>

        <Link
          to="/manage-company"
          className="w-full inline-flex items-center justify-center gap-2 bg-palatte text-white text-sm font-medium px-4 py-2 rounded-md hover:opacity-90 transition"
        >
          <i className="fa-regular fa-plus"></i>
          Create Company
        </Link>
      </div>
    );
  }

  const orgTitle = organization?.name || "Organization";
  const orgExcerpt = organization?.excerpt || "";
  const logo = organization?.logo || null;
  const coverImage = organization?.coverImage || null;

  const firstLetter = orgTitle?.charAt(0)?.toUpperCase();

  return (
    <div className="bg-white rounded-lg overflow-hidden">
      {/* Cover Image */}
      {coverImage && (
        <img
          src={coverImage}
          alt="cover"
          className="w-full h-16 object-cover"
        />
      )}

      <div className="p-4">
        {/* Logo + Name */}
        <div className="flex items-center gap-3 -mt-10">
          {logo ? (
            <div className="w-16 h-16 rounded-md overflow-hidden border bg-white flex items-center justify-center">
              <img
                src={logo}
                alt={orgTitle}
                className="w-full h-full object-contain"
              />
            </div>
          ) : (
            <div className="w-16 h-16 rounded-md bg-gray-200 flex items-center justify-center text-lg font-semibold text-gray-600">
              {firstLetter}
            </div>
          )}

          <div className="mt-6">
            <h3 className="text-base font-bold text-gray-900">{orgTitle}</h3>
            {orgExcerpt && (
              <p className="text-xs text-gray-700 font-medium">{orgExcerpt}</p>
            )}
            {/* View Button */}
            <Link
              to={`/company/${organization?.slug}`}
              className="block text-center text-sm text-palatte hover:underline"
            >
              View Company
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrganizationCard;
